import { z } from 'zod';
import { NUMBERS_REG_EXP } from '@/shared/const';
import { isAtLeastTomorrow, isValidDate, isWeekday, parseDirtyDateString } from '@/shared/lib/utils/auxiliaryFuncitions';

// const PHONE_NUMBER_REGEXP = /^\+7 \(9\d{2}\) \d{3}-\d{2}-\d{2}$/;
// const RUSSIAN_AND_SYMBOLS_REGEXP = /^[а-яА-ЯёЁ \-\–']+$/;
// const ENDS_WITH_REGEXP = /^[^-\– '][а-яА-ЯёЁ \-\–']*[^\-\– ']$/;
// const DUPLICATE_REGEXP = /^(?!.*[-\– ']{2})/;
// const EMAIL_REGEXP = /^(?!\.)(?!.*\.\.)([A-Z0-9_+\-\.]*)[A-Z0-9_+-]@[A-Z0-9\-]+\.[A-Z]{2,}$/i;
const EMPTY_WITH_SPACE = /^(?!\s*$).+/;

const baseSchema = z.object({
    fio: z.string(),
    phone: z.string(),
    email: z.string(),
    insurancePayment: z.string(),
    depositDate: z.any(),
    depositTime: z.any(),
});

export const DepositSchema = baseSchema.superRefine((data, ctx) => {
    const { depositDate, insurancePayment } = data;

    const preparedDate = parseDirtyDateString(depositDate);
    const preparedInsurancePayment = insurancePayment
        .split('')
        .filter((el) => NUMBERS_REG_EXP.test(el))
        .join('');

    if (
        preparedInsurancePayment === undefined ||
        preparedInsurancePayment === '' ||
        !EMPTY_WITH_SPACE.test(preparedInsurancePayment)
    ) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['insurancePayment'],
            message: 'Это обязательное поле',
        });
    }

    if (preparedInsurancePayment) {
        if (Number(preparedInsurancePayment) < 10000) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['insurancePayment'],
                message: 'Для пополнения необходимо ввести сумму больше 10 000 руб.',
            });
        }
    }

    if (preparedInsurancePayment) {
        if (Number(preparedInsurancePayment) > 50000000) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['insurancePayment'],
                message: 'За одно пополнение можно ввести не более 50 млн. рублей.',
            });
        }
    }

    if (preparedDate === undefined || preparedDate === '') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['feedbackDate'],
            message: 'Это обязательное поле',
        });
    }

    if (!isValidDate(depositDate)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['depositDate'],
            message: 'Некорректный формат даты',
        });
    }

    if (!isAtLeastTomorrow(preparedDate)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['depositDate'],
            message: 'Выберите дату в будущем',
        });
    }

    if (!isWeekday(preparedDate)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['depositDate'],
            message: 'Выберите будний день',
        });
    }
});

export type DepositSchemaType = z.infer<typeof DepositSchema>;
